import { render, staticRenderFns } from "./FormPerfil.vue?vue&type=template&id=69e66d77"
import script from "./FormPerfil.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormPerfil.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports